import { RecoilRoot } from "recoil";
import "./src/styles/global.css";
import React from "react";
import Layout from "./src/components/layout";
import type { GatsbyBrowser } from "gatsby";
import {
  readConsentChoice,
  loadAnalytics,
  removeAnalyticsCookies,
  trackPageView,
} from "./src/components/cookies/analytics";

export const wrapPageElement = ({ element }) => {
  return (
    <RecoilRoot>
      <Layout>{element}</Layout>
    </RecoilRoot>
  );
};

// Google Analytics startuje tylko, jesli uzytkownik wczesniej kliknal "Zgoda".
// W przeciwnym razie sprzatamy ewentualne _ga z czasow sprzed zmiany banera.
export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  readConsentChoice() === "allow" ? loadAnalytics() : removeAnalyticsCookies();
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  trackPageView(location);
};
